import React, { Fragment } from 'react';
import Amplify from 'aws-amplify';
import { AmplifyConfig } from './aws-export';
import Routes from './routes/routes';

Amplify.configure(AmplifyConfig);


const App: React.FC = (): JSX.Element => {
  return (
    <Fragment>
      <Routes/>
    </Fragment>
  );
};

export default App;
